import React, { Component } from 'react';

import { Helmet } from 'react-helmet';

import { Box } from '@mui/material';

import Asinc from '~/components/Common/Asinc';
import OfferBreadcrumbs from '~/components/Common/Elements/OfferBreadcrumbs';
import PageHeader from '~/components/Common/Elements/PageHeader';
import TourForm from '~/components/Common/Forms/TourForm';

import ReservationService from '~/services/ReservationService';
import VendorsService from '~/services/VendorsService';

export default class TourNewContainer extends Component {
  constructor(props) {
    super(props);

    const { match } = props;
    this.vendorId = match.params.id_vendor;

    this.fetchData = this.fetchData.bind(this);
  }

  async fetchData() {
    const [schema, vendor] = await Promise.all([
      ReservationService.getTourSchema(),
      VendorsService.getVendorById(this.vendorId),
    ]);

    return {
      schema: schema.post.body.schema,
      vendor: vendor.result,
    };
  }

  render() {
    return (
      <div className="container tour-edit-form">
        <Asinc
          promise={this.fetchData()}
          then={({ schema, vendor }) => {
            const tour = { id_salesforce_external: this.vendorId };

            return (
              <>
                <Helmet>
                  <title>Vendors | {vendor?.name || this.vendorId} | Create Tour</title>
                </Helmet>
                <OfferBreadcrumbs
                  vendor={{
                    label: vendor?.vendor_name || vendor?.name || 'Vendor',
                    href: `/vendors/${this.vendorId}`,
                  }}
                  currentPage="Create tour"
                />
                <PageHeader title="Create Tour" />
                <Box id="overview" className="tour-deal-section">
                  <TourForm schema={schema} tour={tour} vendorId={this.vendorId} />
                </Box>
              </>
            );
          }}
        />
      </div>
    );
  }
}
